import React, { useEffect, useState } from 'react';
import {
  Button,
  Card,
  CardBody,
  CardImg,
  CardSubtitle,
  CardText,
  CardTitle,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner,
  UncontrolledTooltip,
} from 'reactstrap';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntityMeetingDetails } from 'app/entities/meetinginfo/meetinginfo.reducer';
import MeetingLinkCopyButton from './MeetingLinkCopyButton';
import axios from 'axios';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { Translate, getSortState, JhiPagination, JhiItemCount } from 'react-jhipster';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';

import FeedbackModal from './feedbackModal';
import { getMeetingAgenda } from 'app/entities/meeting/meeting.reducer';
import ViewFeedBack from './ViewFeedBack';
const Meetings = () => {
  const meetinginfoEntity = useAppSelector(state => state.meetinginfo.entity);
  const account = useAppSelector(state => state.authentication.account);
  const [meetingData, setMeetingData] = useState([]);
  const [recordingLink, setRecordingLink] = useState([]);
  const [showAllProfiles, setShowAllProfiles] = useState(false);
  const [modal, setModal] = useState(false);
  const [videoUrl, setVideoUrl] = useState('');
  const [agendaModal, setAgendaModal] = useState(false);
  const [feedBackModal, setFeedBackModal] = useState({ isOpen: false, id: null });
  const [viewFeedBack, setViewFeedBack] = useState({ isOpen: false, id: null });
  const agendaData = useAppSelector(state => state.meeting.entity?.meetingAgenda);
  const agendaloader = useAppSelector(state => state.meeting.loading);

  const baseImageUrl = '/profile/get/image';

  // const [currentDate, setCurrentDate] = useState(() => {
  //   const date = new Date();
  //   date.setHours(date.getHours());
  //   return date;
  // });
  const [currentDate, setCurrentDate] = useState(new Date());
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentDate(new Date());
    }, 1000); // Update every 1000 milliseconds (1 second)

    // Clear the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, [meetinginfoEntity]);
  const toggleModal = () => {
    //modal ? setIsButtonVisible(false):"";
    setModal(!modal);
  };
  const dispatch = useAppDispatch();
  const meetingUrl = 'api/updateMeetingStatus';
  const downloadUrl = '/api/download/meeting/recordings';
  const [loading, setLoading] = useState(false);
  const loggedInUserId = account.id;
  const [totalMeetingItems, setTotalMeetingItems] = useState(Number);
  const [showMoreMap, setShowMoreMap] = useState({});
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(location, 20, 'id'), location.search)
  );
  const toggleShowAllProfiles = () => {
    setShowAllProfiles(!showAllProfiles);
  };

  useEffect(() => {
    dispatch(
      getEntityMeetingDetails({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
      })
    );
  }, [paginationState]);

  const fetchAgenda = meeting => {
    if (!meeting) return;

    const isGuest = meeting?.guests.some(guest => loggedInUserId === guest.user.id);
    const payload = {
      meetingId: meeting.id,
      ...(isGuest ? { mentorId: account.id } : { menteeId: account.id }),
    };
    dispatch(getMeetingAgenda(payload));
  };

  useEffect(() => {
    if (meetinginfoEntity && Object.keys(meetinginfoEntity).length > 0) {
      const contentArray = meetinginfoEntity.content || [];
      meetinginfoEntity.totalElements != undefined ? setTotalMeetingItems(meetinginfoEntity.totalElements) : '';
      const formattedMeetingData = [];

      for (const contentItem of contentArray) {
        for (const dateKey in contentItem) {
          if (contentItem.hasOwnProperty(dateKey)) {
            const meetingsForDate = contentItem[dateKey];

            if (Array.isArray(meetingsForDate)) {
              const filteredMeetings = meetingsForDate.filter(meeting => meeting && meeting.meetingCreator);

              if (filteredMeetings.length > 0) {
                formattedMeetingData.push({
                  date: dateKey,
                  meetings: filteredMeetings,
                });
              }
            }
          }
        }
      }
      setMeetingData(formattedMeetingData);
    }
  }, [meetinginfoEntity]);

  const toggleShowMore = recordIndex => {
    setShowMoreMap(prevState => ({
      ...prevState,
      [recordIndex]: !prevState[recordIndex],
    }));
  };

  const toggleFeedBack = () => {
    setFeedBackModal({ isOpen: false, id: null });
  };

  const toggleViewFeedBack = () => {
    setViewFeedBack({ isOpen: false, id: null });
  };

  const toggleMeetingAgenda = () => {
    setAgendaModal(false);
  };

  const acceptMeeting = async (userID, meetID) => {
    setLoading(true);
    try {
      const requestUrl = `${meetingUrl}?guestId=${userID}&meetingId=${meetID}&status=true&type=Meeting`;
      const response = await axios.put(requestUrl);
      if (response.status === 200) {
        await dispatch(
          getEntityMeetingDetails({
            page: paginationState.activePage - 1,
            size: paginationState.itemsPerPage,
          })
        );
        setLoading(false);
      }
    } catch (error) {}
  };
  const downloadMeeting = async meetID => {
    setLoading(true);
    toggleModal();
    try {
      const requestUrl = `${downloadUrl}?meetingId=${meetID}`;
      const response = await axios.get(requestUrl);

      if (response.status === 200) {
        setVideoUrl(response.data);

        setLoading(false);
      }
    } catch (error) {
      console.error('Error:', error);
      setVideoUrl('');
      setLoading(false);
    }
  };
  useEffect(() => {}, [recordingLink]);

  const handlePagination = async currentPage => {
    setLoading(true);
    await setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

    await dispatch(
      getEntityMeetingDetails({
        page: currentPage - 1,
        size: paginationState.itemsPerPage,
      })
    );
    setLoading(false);
  };
  return (
    <Row className="meeting-tab-inner">
      <Col md="12">
        <div className="card meeting-border">
          {meetinginfoEntity && Object.keys(meetinginfoEntity).length > 0 ? (
            meetingData.map((dateGroup, index) => (
              <div className="meeting-tab-by-date" key={index}>
                <h2>Meeting date: {new Date(dateGroup.date).toLocaleDateString('en-GB')}</h2>
                {dateGroup.meetings.map((meeting, meetingIndex) => (
                  <Card className="p-0 mb-2 connection-card " key={meetingIndex}>
                    <CardBody className="d-flex justify-content-between align-items-center">
                      <div>
                        <div className="d-flex align-items-center">
                          <CardTitle tag="h5" className="mb-0 me-2 text-break">
                            {meeting.meetingCreator.name}
                          </CardTitle>
                          <Button
                            color="light"
                            className="rounded-pill px-2 py-0 border text-bold Meeting-buttons"
                            onClick={() => {
                              setAgendaModal(true);
                              fetchAgenda(meeting?.meetingCreator); // call immediately
                            }}
                          >
                            Meeting Agenda
                          </Button>
                          {meeting.meetingCreator.user &&
                            meeting.meetingCreator.user.id === loggedInUserId &&
                            meeting.meetingCreator.dailyCoLink !== null && (
                              <div className="d-flex align-items-center px-2">
                                {new Date(meeting.meetingCreator.meetingTime).getTime() + meeting.meetingCreator.duration <
                                  currentDate.getTime() && (
                                  <Button
                                    color="light"
                                    className="rounded-pill px-2 py-0 border text-bold Meeting-buttons"
                                    onClick={() => {
                                      setViewFeedBack({ isOpen: true, id: meeting.meetingCreator?.id });
                                    }}
                                  >
                                    View FeedBack
                                  </Button>
                                )}
                              </div>
                            )}
                          {meeting.meetingCreator.guests &&
                            meeting.meetingCreator.guests.some(
                              guest => loggedInUserId === guest.user.id && guest.dailyCoGuestLink !== null
                            ) && (
                              <div className="d-flex align-items-center px-2">
                                {new Date(meeting.meetingCreator.meetingTime).getTime() + meeting.meetingCreator.duration <
                                currentDate.getTime() ? (
                                  <Button
                                    color="light"
                                    className="rounded-pill px-2 py-0 border text-bold Meeting-buttons"
                                    onClick={() => {
                                      setFeedBackModal({ isOpen: true, id: meeting.meetingCreator?.id });
                                    }}
                                  >
                                    FeedBack
                                  </Button>
                                ) : (
                                  ''
                                )}
                              </div>
                            )}
                        </div>

                        <div className="d-flex">
                          <p className="pe-3">{new Date(meeting.meetingCreator.meetingTime).toLocaleDateString('en-GB')}</p>
                          <p className="meeting-time-border">{new Date(meeting.meetingCreator.meetingTime).toLocaleTimeString()}</p>
                          <p className="ps-3">{meeting.meetingCreator.duration / 60000} minutes</p>
                        </div>
                        <div className="menbers-info">
                          <div className="connection-avtar d-flex meeting-org-avtar">
                            <CardImg
                              id={`avatar-${index}-${meetingIndex}`}
                              className="rounded-circle image-user-org"
                              src={`${baseImageUrl}/${meeting.meetingCreator.user.imageUrl}`}
                            />
                            <UncontrolledTooltip placement="top" target={`avatar-${index}-${meetingIndex}`}>
                              {meeting.meetingCreator.user.firstName} {meeting.meetingCreator.user.lastName}
                            </UncontrolledTooltip>
                            <div className="meeting-names">
                              <p className="meeting-org-name">
                                {meeting.meetingCreator.user.firstName} {meeting.meetingCreator.user.lastName}
                              </p>
                              <p className="meeting-org">Organizer</p>
                            </div>
                          </div>
                          <div className="d-flex meeting-member">
                            {(meeting?.meetingCreator?.guests || [])
                              .slice(0, showMoreMap[index + meetingIndex] ? undefined : 3)
                              .map((guest, guestIndex) => (
                                <div className="connection-avtar" key={guestIndex}>
                                  <CardImg
                                    id={`guest-avatar-${index}-${meetingIndex}-${guestIndex}`}
                                    className="rounded-circle"
                                    src={`${baseImageUrl}/${guest?.user?.imageUrl}`}
                                  />
                                  <UncontrolledTooltip placement="top" target={`guest-avatar-${index}-${meetingIndex}-${guestIndex}`}>
                                    {guest?.user?.firstName} {guest?.user?.lastName}
                                  </UncontrolledTooltip>
                                </div>
                              ))}

                            {(meeting?.meetingCreator?.guests || []).length > 3 && (
                              <div className="view-more-member">
                                <button onClick={() => toggleShowMore(index + meetingIndex)} className="more-button">
                                  {showMoreMap[index + meetingIndex]
                                    ? '- Less'
                                    : `+${(meeting.meetingCreator.guests || []).length - 3} More`}
                                </button>
                              </div>
                            )}
                          </div>
                          <div className="user-numbers">
                            {meeting.meetingCreator.guests && (
                              <p>
                                {meeting.meetingCreator.guests.filter(guest => guest.status).length} Yes |{' '}
                                {meeting.meetingCreator.guests.filter(guest => !guest.status).length} Waiting
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="meeting-recording">
                        <div className="d-flex align-items-center join-btn">
                          {meeting.guest && !meeting.guest.status && (
                            <button
                              className={`accept-btn ${
                                new Date(meeting.meetingCreator.meetingTime).getTime() + meeting.meetingCreator.duration <
                                currentDate.getTime()
                                  ? 'disabled'
                                  : ''
                              }`}
                              onClick={() => {
                                acceptMeeting(meeting.guest.user.id, meeting.guest.meeting.id);
                              }}
                            >
                              Accept
                            </button>
                          )}
                        </div>
                        <CardSubtitle className="" tag="h6">
                          <div className="d-flex align-items-center join-btn">
                            {loggedInUserId === meeting.meetingCreator.user.id
                              ? meeting.meetingCreator.dailyCoLink && (
                                  <a
                                    href={meeting.meetingCreator.dailyCoLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={`accept-btn ${
                                      new Date(meeting.meetingCreator.meetingTime).getTime() + meeting.meetingCreator.duration <
                                      currentDate.getTime()
                                        ? 'disabled'
                                        : ''
                                    }`}
                                  >
                                    {new Date(meeting.meetingCreator.meetingTime).getTime() + meeting.meetingCreator.duration <
                                    currentDate.getTime()
                                      ? 'Meeting Completed'
                                      : 'Join Now'}
                                  </a>
                                )
                              : meeting.meetingCreator.guests &&
                                meeting.meetingCreator.guests.some(guest => loggedInUserId === guest.user.id) &&
                                meeting.meetingCreator.guests.find(guest => loggedInUserId === guest.user.id).dailyCoGuestLink && (
                                  <a
                                    href={meeting.meetingCreator.guests.find(guest => loggedInUserId === guest.user.id).dailyCoGuestLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={
                                      new Date(meeting.meetingCreator.meetingTime).getTime() + meeting.meetingCreator.duration <
                                      currentDate.getTime()
                                        ? 'disabled'
                                        : ''
                                    }
                                  >
                                    {new Date(meeting.meetingCreator.meetingTime).getTime() + meeting.meetingCreator.duration <
                                    currentDate.getTime()
                                      ? 'Meeting Completed'
                                      : 'Join Now'}
                                  </a>
                                )}{' '}
                          </div>

                          <div className="d-flex align-items-center download-btn">
                            {meeting.recordedMeeting && meeting.recordedMeeting.id && meeting.recordedMeeting?.recordedMeetingId && (
                              <button className="accept-btn" onClick={() => downloadMeeting(meeting.meetingCreator.id)}>
                                View Recording
                              </button>
                            )}
                          </div>
                        </CardSubtitle>
                      </div>
                    </CardBody>
                  </Card>
                ))}
              </div>
            ))
          ) : (
            <div className="meeting-tab-gif">
              <Row>
                <div className="col-md-6">
                  <h4>Schedule Collaborative Sessions</h4>
                  <p>
                    At the moment, you have no scheduled meetings. Before setting up a meeting, ensure you've established connections.
                    Connect with peers, colleagues, and industry professionals first. Once you've built your network, scheduling meetings
                    becomes a seamless process. Every conversation is an opportunity to grow and collaborate.
                  </p>{' '}
                </div>
                <div className="col-md-6">
                  <img src="content/images/meeting-tab.gif" />
                </div>
              </Row>
            </div>
          )}
        </div>

        {meetinginfoEntity ? (
          <div className={meetingData && meetingData.length > 0 ? '' : 'd-none'}>
            <div className="justify-content-center d-flex pagination-sec">
              <JhiItemCount
                page={paginationState.activePage}
                total={totalMeetingItems}
                itemsPerPage={paginationState.itemsPerPage}
                i18nEnabled
              />
            </div>
            <div className="justify-content-center d-flex">
              <JhiPagination
                activePage={paginationState.activePage}
                onSelect={handlePagination}
                maxButtons={5}
                itemsPerPage={paginationState.itemsPerPage}
                totalItems={totalMeetingItems}
              />
            </div>
          </div>
        ) : (
          ''
        )}
        <Modal className="meeting-recording-popup" isOpen={modal} toggle={toggleModal}>
          <ModalHeader toggle={toggleModal}>Meeting Recording</ModalHeader>
          <ModalBody>
            {loading ? (
              <p>Loading...</p>
            ) : (
              <div>
                {videoUrl ? (
                  <video width="640" height="360" controls>
                    <source src={videoUrl} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <div>No recorded video found.</div>
                )}
              </div>
            )}
          </ModalBody>
        </Modal>
      </Col>

      <FeedbackModal meetingId={feedBackModal.id} isOpen={feedBackModal.isOpen} mentorId={account.id} toggle={toggleFeedBack} />
      <ViewFeedBack isOpen={viewFeedBack.isOpen} toggle={toggleViewFeedBack} loading={undefined} meetingId={viewFeedBack.id} />
      <Modal isOpen={agendaModal} toggle={() => toggleMeetingAgenda()}>
        <ModalHeader toggle={() => toggleMeetingAgenda()}>Meeting Info</ModalHeader>

        <ModalBody className="pt-2 px-4 pb-4">
          {agendaloader ? (
            <div className="text-center py-3">
              <Spinner />
            </div>
          ) : agendaData ? (
            <div className="text-center">
              {/* Meeting Title */}
              <h5 className="fw-bold mt-2 text-start text-break">{agendaData?.meetingTitle || 'Untitled Meeting'}</h5>

              {/* Label */}
              <p className="text-muted mb-3 text-start">Question to Mentor</p>

              {/* Questions */}
              {agendaData?.questions?.length > 0 ? (
                agendaData.questions.map((q, index) => (
                  <div key={index} className="bg-light border rounded p-2 mb-2 text-start">
                    {q.question}
                  </div>
                ))
              ) : (
                <p className="text-muted">No question found</p>
              )}
            </div>
          ) : (
            <p className="text-center text-muted">No agenda available</p>
          )}
        </ModalBody>
      </Modal>
      {loading ? (
        <div className="loader_custom">
          <Spinner>Loading...</Spinner>
        </div>
      ) : (
        ''
      )}
    </Row>
  );
};

export default Meetings;
